import { ProductCategory } from '../types/shared/products.js';

const mapProductTypeToProductCategory = (productType)=>{
    switch(productType){
        case 'Frames':
        case 'frames':
        case 'non-prescription-bundle':
        case 'prescription-glasses':
            return ProductCategory.OPTICS;
        case 'Sunglasses':
        case 'sunglasses':
            return ProductCategory.SUN;
        case 'Contact-lenses':
        case 'contact-lenses-bundle-benelux':
        case 'contact-lenses':
            return ProductCategory.CONTACT_LENSES;
        case 'Accessories':
        case 'accessories':
        case 'Solutions':
            return ProductCategory.ACCESSORIES;
        case 'Ready-readers':
        default:
            return ProductCategory.EYEWEAR;
    }
};

export { mapProductTypeToProductCategory };
//# sourceMappingURL=map-product-type-to-product-category.js.map
